module.exports = __webpack_public_path__ + "static/media/report_plus.027696e9.svg";